/*
 * @Descripttion:
 * @version:
 * @Author: shiqiong
 * @Date: 2021-09-07 10:19:38
 * @LastEditors: shiqiong
 * @LastEditTime: 2021-09-07 11:16:12
 */
const arrangeRouter = [

  {
    path: 'arrange',
    name: 'Arrange',
    component: () => import('@/views/wxapp/bulletin-board/arrange/index'),
    meta: {
      title: '排行榜'
    }
  }
]
export default arrangeRouter
